/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { Button as AntdButton, ButtonProps as AntdButtonProps} from "antd";
import { PositionIcons, TypeButton, SizeButton, UiStates, PrefixClassName} from "src/constants/theme.constant";

type ButtonProps = AntdButtonProps & {
  className?: string,
  mode?: TypeButton,
  hasIcon?: boolean,
  position?: PositionIcons,
  customSize?: SizeButton,
  float?: boolean,
  state?: UiStates,
};

const Button = ({
  className,
  mode = TypeButton.Primary,
  hasIcon,
  customSize = SizeButton.Normal,
  float,
  state = UiStates.Default,
  position = PositionIcons.Start,
  ...props
} : ButtonProps) => {
  return (
    <>
      <AntdButton
        {...props}
        iconPosition={position}
        type="primary"
        className={
          `${PrefixClassName}-btn-${mode} 
          ${customSize !== SizeButton.Normal && !float ? `${PrefixClassName}-btn--${customSize}` : ''} 
          ${state !== UiStates.Default ? `${PrefixClassName}-btn-${mode}--${state}`:''}
          ${hasIcon && position ? position === PositionIcons.End ? `${PrefixClassName}-btn--icon-end` : `${PrefixClassName}-btn--icon`:''}
          ${props.block && !float? `${PrefixClassName}-btn--block`:''}
          ${float? `${PrefixClassName}-btn--float`:''} ${className ?? ''}`
        }
        target={props.href?'_blank':'_self'}
      />
    </>
  );
};

export default Button;
